// src/lib/origensNegociacao.ts
//
// Origens possíveis de uma negociação — a lista que o CRM oferece nos selects.
//
// Existia copiada em três telas (o wizard de nova negociação, o detalhe da
// negociação e o filtro do Kanban). Virou fonte única quando "Licitação"
// entrou: uma lista esquecida deixaria a opção invisível em uma das telas, e o
// canal Licitação do Painel Executivo depende deste campo estar preenchido.
//
// ORDEM: alfabética, com "Outros" no fim — é o descarte, não uma opção como as
// demais.

export const ORIGEM_LICITACAO = 'Licitação';

export const ORIGENS_NEGOCIACAO = [
  'Busca orgânica',
  'Concorrentes',
  'Evento',
  'Indicação',
  ORIGEM_LICITACAO,
  'Mídia paga',
  'Prospecção ativa',
  'Prospecção geográfica',
  'Redes sociais',
  'Site',
  'Outros',
] as const;

/**
 * Origem que só o banco grava: o lead que chegou pelo link do parceiro (#6511).
 * Fica fora da lista do cadastro manual para a origem continuar medindo o link
 * (o parceiro não marca à mão um lead que ele mesmo trouxe de outro jeito).
 */
export const ORIGEM_LINK_PARCEIRO = 'Link do parceiro';

/** A lista dos filtros inclui "Desconhecido": é como o Kanban chama quem está sem origem. */
export const ORIGENS_PARA_FILTRO = [...ORIGENS_NEGOCIACAO, ORIGEM_LINK_PARCEIRO, 'Desconhecido'];

/**
 * A negociação veio de licitação?
 *
 * Compara sem acento e sem caixa porque o campo é texto livre no banco: há
 * registro antigo gravado por importação, e "licitacao" não pode virar um canal
 * diferente de "Licitação".
 */
export function ehLicitacao(origem: string | null | undefined): boolean {
  return chave(origem) === chave(ORIGEM_LICITACAO);
}

const chave = (v: string | null | undefined): string =>
  (v || '').normalize('NFD').replace(/\p{Mn}/gu, '').trim().toLowerCase();
